
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

export interface TabItem {
  name?: string,
  title: string,
  icon?: string,
  iconColor?: string,
  to?: RawLocation
}

@Component
export default class BaseTabs extends Vue {
  @Prop({ default: true }) isLink!: boolean;

  @Prop({ required: true }) tabs!: TabItem[];

  @Prop({ default: '' }) activeTabName!: string;

  @Prop({ default: false }) hideTitles!: boolean;

  @Prop({ default: false }) hideTitlesExceptActive!: boolean;

  @Prop({ default: null }) minWidth!: number;

  @Prop({ default: false }) reversed!: boolean;

  private tabStyle = {};

  get tabComponent(): string {
    return this.isLink ? 'router-link' : 'div';
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  @Watch('minWidth')
  private recalculateTabStyle(): void {
    this.calculateTabStyle();
  }

  private mounted(): void {
    this.calculateTabStyle();
    window.addEventListener('resize', this.calculateTabStyle);
  }

  destroyed(): void {
    window.removeEventListener('resize', this.calculateTabStyle);
  }

  private calculateTabStyle(): void {
    const { length: tabsQty } = this.tabs;
    const width = 100 / tabsQty + 2;
    const minWidth = this.minWidth ? `${this.minWidth}px` : 'auto';
    const totalTabsWidth = width * tabsQty;
    let marginLeft = (100 - totalTabsWidth) / (tabsQty - 1);

    if (this.minWidth) {
      const { container } = this.$refs;
      const minWidthInPercent = (this.minWidth / (container as HTMLElement).clientWidth) * 100;
      const canFit = minWidthInPercent * tabsQty + (marginLeft * (tabsQty - 1)) <= 100;
      const totalTabsMinWidth = minWidthInPercent * tabsQty;

      if (!canFit) {
        marginLeft = (100 - totalTabsMinWidth) / (tabsQty - 1);
      }
    }

    this.tabStyle = {
      flex: `0 0 ${width}%`,
      marginLeft: `${marginLeft}%`,
      minWidth,
    };
  }

  private isActive(tab: TabItem): boolean {
    if (this.isLink) {
      return this.$route.fullPath === this.$router.resolve(tab.to as RawLocation).href;
    }

    return this.activeTabName === tab.name;
  }

  private getIsShowTitle(tab: TabItem): boolean {
    if (this.hideTitles) {
      return false;
    }

    if (this.hideTitlesExceptActive) {
      return this.isActive(tab);
    }

    return true;
  }
}
